export { EloArrowLeftIcon } from './arrow-left-icon'
